import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import langEn from './lang.en.json';
import langKo from './lang.ko.json';
import langVi from './lang.vi.json';

const resource = {
    'en-US': {
        translation: langEn
    },
    'ko-KR': {
        translation: langKo
    },
    'vi-VN': {
        translation: langVi
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources: resource,
        // 초기 설정 언어
        lng: 'ko-KR',
        fallbackLng: {
            'en-US': ['en-US'],
            'vi-VN': ['vi-VN'],
            'ko-KR': ['ko-KR'],
            default: ['ko-KR']
        },
        debug: false,
        defaultNS: 'translation',
        ns: 'translation',
        keySeparator: false,
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }
    })

export default i18n;